var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v("Instagram Feature"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Kanal Sayısı")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c("a-input", {
              staticClass: "plan-input",
              attrs: { min: 0, type: "number" },
              model: {
                value: _vm.featureForm.instagramChannelCount,
                callback: function ($$v) {
                  _vm.$set(_vm.featureForm, "instagramChannelCount", $$v)
                },
                expression: "featureForm.instagramChannelCount",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramMentionTicket,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagramMentionTicket", $$v)
                  },
                  expression: "featureForm.instagramMentionTicket",
                },
              },
              [_vm._v("Mention Ticket")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramPrivateReplyMessage,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.featureForm,
                      "instagramPrivateReplyMessage",
                      $$v
                    )
                  },
                  expression: "featureForm.instagramPrivateReplyMessage",
                },
              },
              [_vm._v("Private Reply Message")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramCommentManagement,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagramCommentManagement", $$v)
                  },
                  expression: "featureForm.instagramCommentManagement",
                },
              },
              [_vm._v("Comment Management")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramManageInbox,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagramManageInbox", $$v)
                  },
                  expression: "featureForm.instagramManageInbox",
                },
              },
              [_vm._v("Manage Inbox")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.instagramManageWithChatbot,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "instagramManageWithChatbot", $$v)
                  },
                  expression: "featureForm.instagramManageWithChatbot",
                },
              },
              [_vm._v("Manage with Chatbot")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }